import { convertToLocalStyle } from './utils/convert-style';
import { scrollbarStyle } from './shared-styles-from-theme-fluent';

const headeWidth = 78;
const paddingOfAll = 8;

export const audienceAssociationSectionStyle = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }, { singleListBoxWidth = 610 } = {}) => ({
  '& .association-section, & .audience__exclusion, & .audience__association': {
    '& .bid-adjustment-section': {
      '& .form-group:nth-child(3)': {
        '& .inline-control': {
          width: 'auto',
          paddingLeft: 0,
          paddingRight: 0,
        },
        '& #bidAdjustInput': {
          marginLeft: 7,
          marginRight: 9,
        },
      },
    },
    '& .cashback-settings-section': {
      '& .cashback-percent-cell': {
        '& input': {
          marginLeft: 7,
          marginRight: 9,
          paddingLeft: 8,
        },
        '& select': {
          width: 185,
        },
      },
    },
    '& .DMP_doublelistbox_section': {
      marginBottom: 0,
      ...convertToLocalStyle(scrollbarStyle({ palette })),

      '& .dmp_select_section': {
        padding: 0,
        marginBottom: 8,
      },

      '& .doubleListBox': {
        width: 1240,
        position: 'relative',

        '& .layout-columns-element:nth-child(1)': {
          float: 'none',
          height: 48,
          position: 'absolute',
          zIndex: 1,

          '& .form-group:nth-child(1)': {
            marginBottom: '0 !important',
            width: singleListBoxWidth,
            height: 48,

            '& .dlb-filter-alignPlaceholder': {
              width: '100%',
              '& .searchbox-input': {
                width: singleListBoxWidth,
                height: 48,
                paddingLeft: '48px !important',
                border: `1px solid ${palette.neutralTertiary}`,
              },

              '& .form-control-feedback': {
                position: 'absolute',
                left: 0,
                height: 48,
                width: 16,
                lineHeight: '48px',
                marginTop: '-3px',
                pointerEvents: 'auto',
              },
            },
          },
        },

        '& .audience-association-selector-item-table.ineligible-ima': {
          color: '#605E5C',
        },

        '& .layout-columns-element:nth-child(3)': {
          '& .panel-heading': {
            marginTop: '0 !important',
          },
        },

        '& .layout-columns-element': {
          width: singleListBoxWidth,
          paddingRight: 10,
          boxSizing: 'content-box',

          '& .panel-form': {
            padding: 1,
            '& .panel-heading': {
              backgroundColor: `${palette.white} !important`,
              border: 0,
              padding: '0 8px !important',
              marginTop: '48px !important',
              height: 36,
            },

            '& .panel-body': {
              '& .dlb-source-container, & .dlb-selected-container': {
                '& .dlb-selected-header, .dlb-source-header': {
                  width: `${headeWidth}%`,
                },
                '& .audience-association-selector-header': {
                  border: '0 !important',
                  padding: '0 !important',
                  height: 36,
                  lineHeight: '36px !important',
                },

                '& .dlb-selectAll, .dlb-deselectAll': {
                  position: 'absolute',
                  zIndex: 1,
                  right: 8,
                  textAlign: 'right',

                  '& span': {
                    color: palette.themePrimary,
                    whiteSpace: 'break-spaces',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    display: 'inline-block',
                    width: '100%',
                    maxWidth: 72,
                  },

                  '& .arrow-button': {
                    display: 'none',
                  },
                },

                '& .dlb-selectAll': {
                  top: 48,
                },

                '& .dlb-deselectAll': {
                  top: 40,
                },

                '& .dlb-source-header, & .dlb-selected-header, & .k-loading-mask': {
                  padding: `0 ${paddingOfAll}px`,
                },

                '& .dlb-source-list, & .dlb-selected-list': {
                  height: '200px !important',

                  '& .dlbItem': {
                    minHeight: 28,
                    position: 'relative',
                    padding: [5, 8],
                    margin: 0,

                    '& .audience-association-selector-item-name-text, & .tree-item, & .audience-association-selector-item-col': {
                      display: 'flex',
                    },

                    '& .audience-association-selector-item-col': {
                      float: 'left',
                    },

                    '& .audience-association-selector-item-listitem-col, .audience-association-selector-item-listitem-col-bulk': {
                      flexDirection: 'row-reverse',
                      alignItems: 'center',
                    },

                    '& .glyphicon-triangle-right, & .glyphicon-triangle-bottom': {
                      marginRight: 5,
                      marginTop: 3,
                    },

                    '& .dlbItem-actions, & .remove': {
                      position: 'absolute',
                      right: 8,
                      top: 4,
                    },

                    '& .dlbItem-content': {
                      minHeight: 28,
                      padding: '4px 0',
                      display: 'inline',

                      '& table': {
                        width: `${headeWidth}%`,

                        '& .audience-association-selector-item-col': {
                          textAlign: 'left',
                          width: '50%',
                        },
                        '& .audience-association-selector-item-col.audience-association-selector-item-listitem-col': {
                          textAlign: 'right',
                          width: '50%',
                          height: '100%',
                        },
                        '& .audience-association-selector-item-col.audience-association-selector-item-listitem-col-bulk': {
                          textAlign: 'right',
                          width: 'calc(100% / 3)',
                        },
                        '& .tree-indent': {
                          paddingLeft: 10,
                        },
                      },

                      '& span': {
                        wordBreak: 'break-word',
                        overflowWrap: 'break-word',
                      },

                      '& .audience-association-selector-item-listsize-text': {
                        '& .tree-listsize': {
                          display: 'inline-block',
                        },
                        '& .audience-association-internalization': {
                          display: 'inline-block',
                          width: 12,
                          height: 12,
                          marginLeft: 12,
                        },
                      },
                    },
                  },

                  '& .disabled': {
                    '& .arrow-button:before': {
                      content: '""',
                    },
                  },
                },

                '& .dlb-source-list.dlb-source .selectable-treeview .dlbItem': {
                  padding: 0,
                  margin: 0,

                  '& .dlbItem-actions': {
                    top: 0,

                    '&>a.tree-action': {
                      position: 'relative',
                      top: 7,
                    },
                  },

                  '& .dlbItem-content': {
                    padding: 0,

                    '& .audience-association-selector-item-table': {
                      // width: '100%',

                      '& .tree-item': {
                        padding: [5, 8],

                        '&>td': {
                          // width: '35%',

                          '& .tree-text': {
                            marginTop: 2,
                          },
                        },
                      },
                    },
                  },
                },
                '& .dlb-selected-list': {
                  height: '284px !important',
                },

                '& .dlb-emptyMessage': {
                  padding: '0 8px',
                  height: 36,
                  lineHeight: '36px',
                  marginBottom: 0,

                  '& p': {
                    marginBottom: 0,
                  },
                },

                '& .dlb-emptyMessage[style="display: none;"] + .dlb-source-list': {
                  height: '236px !important',
                },

                '& .empty-message-action': {
                  marginBottom: 0,
                },
              },
            },
          },

          '& .dlb-pager-container': {
            width: 'auto',
            float: 'right',
            marginTop: 8,

            '& .pager': {
              height: 'auto',
            },
          },
        },
        '& .dlb-internalzation-popover.representation': {
          '& .popover-title-content__title-text': {
            fontWeight: 'bold',
          },
        },

        '& .dlb-internalzation-popover': {
          zIndex: 2,

          '& .popover-view': {
            background: '#ffffff',
            border: 'solid 1px #BBB',
            padding: 15,
            maxHeight: 400,
            overflow: 'auto',
            width: 262,

            '& .popover-view__dismiss': {
              width: 10,
              height: 10,
            },

            '& .popover-titled-content__title': {
              marginBottom: 8,
            },

            '& .popover-view__content': {
              paddingTop: 9,
              paddingBottom: 9,
              fontSize: 12,
              '& .market-lists': {
                wordBreak: 'break-word',
              },
              '& .table-bordered': {
                margin: 0,

                '& thead>tr>td': {
                  'border-bottom-width': 1,
                },

                '& thead>tr>td:nth-child(1)': {
                  borderLeft: 0,
                },

                '& thead>tr>td:nth-child(2)': {
                  borderRight: 0,
                },

                '& thead>tr>th:nth-child(2)': {
                  textAlign: 'right',
                },
              },
            },
          },
        },
        '& .pager-container': {
          '& select': {
            '-webkit-appearance': 'none !important',
            background: 'url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMiAxMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM0ODQ2NDQ7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5BcnRib2FyZCAxPC90aXRsZT48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xMS4zNyw0bC41Mi41M0w2LDEwLjQ1LjEyLDQuNTYuNjQsNCw2LDkuNFoiLz48L3N2Zz4=") no-repeat right 8px top 8px transparent !important',
            backgroundSize: '14px !important',
            '&.disabled,&[disabled]': {
              background: `url("data:image/svg+xml;base64,PHN2ZyBkYXRhLW5hbWU9IkxheWVyIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDEyIDEyIj48cGF0aCBkPSJNMTEuMzcgNGwuNTIuNTNMNiAxMC40NS4xMiA0LjU2LjY0IDQgNiA5LjR6IiBmaWxsPSIjYTZhNmE2Ii8+PC9zdmc+") no-repeat right 8px top 8px ${palette.neutralLighter} !important`,
              backgroundSize: '14px !important',
            },
          },
        },
        '& .pager-selected-container': {
          '& select': {
            '-webkit-appearance': 'none !important',
            background: 'url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMiAxMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM0ODQ2NDQ7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5BcnRib2FyZCAxPC90aXRsZT48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xMS4zNyw0bC41Mi41M0w2LDEwLjQ1LjEyLDQuNTYuNjQsNCw2LDkuNFoiLz48L3N2Zz4=") no-repeat right 8px top 8px transparent !important',
            backgroundSize: '14px !important',
            '&.disabled,&[disabled]': {
              background: `url("data:image/svg+xml;base64,PHN2ZyBkYXRhLW5hbWU9IkxheWVyIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDEyIDEyIj48cGF0aCBkPSJNMTEuMzcgNGwuNTIuNTNMNiAxMC40NS4xMiA0LjU2LjY0IDQgNiA5LjR6IiBmaWxsPSIjYTZhNmE2Ii8+PC9zdmc+") no-repeat right 8px top 8px ${palette.neutralLighter} !important`,
              backgroundSize: '14px !important',
            },
          },
        },
        '& .audience-association-internalization-info': {
          borderBottom: '1px dashed #0078D4',
          width: 'fit-content',
          cursor: 'pointer',
          display: 'inline',
        },
      },

      '& #InMarket.associationDoubleListBoxControl, & #InMarket.exclusionDoubleListBoxControl': {
        '& .audience-association-selector-item-name-text': {
          '& span': {
            overflowWrap: 'break-word',
          },
        },

        '& .glyphicon-triangle-bottom': {
          fontFamily: iconFontFamily,
          fontSize: 12,
        },

        '& .glyphicon-triangle-bottom:before': {
          content: '"\\E70D"',
        },

        '& .glyphicon-triangle-right': {
          fontFamily: iconFontFamily,
          fontSize: 12,
        },

        '& .glyphicon-triangle-right:before': {
          content: '"\\E76C"',
        },
      },

      '& #Product .empty-message-action a': {
        verticalAlign: 'bottom',
      },
    },

    '& .type-bold': {
      marginTop: 8.5,
      marginBottom: 10,
      fontSize: 16,
    },

    '& hr': {
      marginTop: 0,
      marginBottom: 17,
      border: 0,
      borderTop: [1, 'solid', '#A2A2A2'],
    },

    '& p': {
      marginBottom: 8.5,
    },

    '& .col-sm-12': {
      padding: 0,

      '& .form-control': {
        width: 205,
      },

      '& .form-group': {
        marginBottom: 10,
      },

      '& .layout-columns-container': {
        '& .dlb-filter-alignPlaceholder': {
          padding: 0,
          '& .has-feedback': {
            '& .searchbox-searchbutton': {
              fontSize: 16,
              outline: 'none',
              height: 48,
              width: 48,
              padding: 14,
            },
            '& .searchbox-searchbutton:focus': {
              border: `1px solid ${palette.neutralSecondary}`,
            },
          },
        },

        '& .layout-columns-element': {
          paddingLeft: 0,

          '& .panel-form': {
            border: [1, 'solid', '#BBB'],

            '& .panel-heading': {
              backgroundColor: '#E5E5E5',
              padding: [0, 15],

              '& .panel-title': {
                marginTop: 0,
                fontSize: 16,
                lineHeight: '20px',
                width: '80%',
              },
            },

            '& .panel-body': {
              padding: 0,
              '& .dlb-selected-container:not(.dlb-source-container)': {
                paddingTop: '20px',
              },
              '& .dlb-source-container:not(.dlb-selected-container)': {
                paddingBottom: '20px',
              },
              '& .dlb-source-container , & .dlb-selected-container': {
                '& .dlb-source-header, .dlb-selected-header': {
                  height: 36,
                  '& .audience-association-selector-header': {
                    padding: [5, 17, 5, 10],
                    borderTop: [1, 'solid', '#BBB'],
                    borderBottom: [1, 'solid', '#BBB'],
                    lineHeight: '20px',

                    '& .audience-association-selector-header-table': {
                      width: '100%',

                      '& .audience-association-selector-header-col': {
                        fontWeight: 600,
                      },
                      '& .audience-association-selector-header-col.audience-association-selector-header-listsize-col': {
                        width: '50%',
                      },

                      '& .audience-association-selector-header-col.audience-association-selector-header-listsize-col-bulk': {
                        width: 'calc(100% / 3)',
                      },

                      '& .audience-association-selector-header-col.audience-association-selector-header-name-col': {
                        '& .appListItem-text': {
                          '& span': {
                            display: 'inline-block',
                            verticalAlign: 'middle',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                          },
                        },
                      },

                      '& .audience-association-selector-header-listsize-col, .audience-association-selector-header-listsize-col-bulk': {
                        textAlign: 'right',

                        '& .appListItem-text': {
                          display: 'flex',
                          justifyContent: 'flex-end',
                          float: 'right',

                          '& span': {
                            display: 'inline-block',
                            verticalAlign: 'middle',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                          },
                        },
                      },
                    },
                  },
                },

                '& .dlb-selectAll': {
                  padding: [5, 10],
                  color: '#1470A5',

                  '& .arrow-button': {
                    fontFamily: iconFontFamily,
                    fontSize: '12px',
                    marginLeft: '12px',
                  },
                  '& .arrow-button:before': {
                    content: '"\\EDBF"',
                  },
                },

                '& .dlb-deselectAll': {
                  padding: [5, 10],
                  color: '#1470A5',

                  '& .arrow-button': {
                    fontFamily: iconFontFamily,
                    fontSize: '12px',
                    marginRight: '12px',
                  },
                  '& .arrow-button:before': {
                    content: '"\\EDBE"',
                  },
                },

                '& .dlb-source-list, .dlb-selected-list': {
                  height: '295px',
                  overflowY: 'scroll',
                },
              },
            },
          },
        },
      },

      '& .dmp:nth-child(3)': {
        '& .dlb-source-list': {
          height: '248px',
        },
      },
    },
  },
  '& .audience__association .association__body .association-section .radio > div > span': {
    marginLeft: 28,
  },
  '& .audience-modal.modal.in': {
    zIndex: 1070,
  },
});
